import styles from 'styles/VideoScreen.module.css'
import pirate from 'assets/images/upcoming/pirate.gif';
import spaceExplorer from 'assets/images/upcoming/spaceExplorer.gif';
import wizard from 'assets/images/upcoming/wizard.gif';

type UpcomingScreenProps = {
  selectedAvatar: string;
  heading?: string;
}

const gifs : { [key: string]: any } = {
  pirate,
  'space explorer': spaceExplorer,
  wizard,
};



function UpcomingScreen ({ selectedAvatar, heading } : UpcomingScreenProps) {
  return (
    <div className={styles.container}>
      <div className={heading ? styles.heading : styles.hidden}>
      { heading }
      </div>
      <div className={styles.megaContainer}>
        <div className={styles.videoContainer}>
          <img
            src={gifs[selectedAvatar]}
            className={styles.video}
          />
        </div>
      </div>
    </div>
  )
}

export default UpcomingScreen;
